import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";

import { TiVoDeviceClientType, useCreateClientType } from "hooks/tivoDevices";
import { FieldProps } from "types/form";
import { pathToUrl } from "utils/url";

import { PATHS } from "../constants";
import { TiVoDeviceForm } from "./components/TiVoDeviceForm";
import { TEXTS } from "./constants";
import { getClientTypeTabs } from "./utils";

type FormType = Omit<TiVoDeviceClientType, "id">;

const fields: FieldProps[] = [
  {
    label: TEXTS.CLIENT_NAME_LABEL,
    name: "name",
  },
  {
    label: "Slug",
    name: "slug",
  },
];

function getInitialValues(): FormType {
  return {
    name: "",
    slug: "",
  };
}

export function TiVoClientTypeAdd() {
  const navigate = useNavigate();
  const { platformId, oemId } = useParams();
  const createClientType = useCreateClientType(platformId, oemId);

  async function handleSubmit(values: FormType) {
    createClientType.mutate(values, {
      onSuccess: (data) => {
        navigate(
          pathToUrl(PATHS.detailsClientType, {
            platformId,
            oemId,
            clientTypeId: data.results.id,
          })
        );
      },
    });
  }
  return (
    <TiVoDeviceForm<FormType>
      updateData={createClientType}
      fields={fields}
      formData={getInitialValues()}
      header={TEXTS.CLIENT_HEADER_NEW}
      onSubmit={handleSubmit}
      tabs={getClientTypeTabs(platformId, oemId)}
    />
  );
}
